import {Component, Inject, Optional} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IValuesHobbies} from 'src/app/interfaces/hr-data.interface';
import {AccessManagementService} from 'src/app/services/access-management.service';
import {roles} from 'src/app/shared/utils/roles';
import {Utils} from 'src/app/shared/utils/utils';
import {DIALOG_DATA} from '../../../../services/dialog.service';
import {DialogRef} from '../../../../shared/ui-kits/dialog/dialog-ref';

@UntilDestroy()
@Component({
  selector: 'app-values-and-hobbies',
  templateUrl: './values-and-hobbies.component.html',
  styleUrls: ['./values-and-hobbies.component.scss'],
})
export class ValuesAndHobbiesComponent {
  public valuesAndHobbiesForm!: UntypedFormGroup;
  public dataValuesAndHobbies!: IValuesHobbies;
  public isEditable = false;
  public validateAllFormFields = Utils.validateAllFormFields;
  public ableToEdit = true;

  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IValuesHobbies,
    private accessService: AccessManagementService
  ) {}

  ngOnInit() {
    this.dataValuesAndHobbies = this.data;
    this.valuesAndHobbiesForm = new UntypedFormGroup({
      employeeId: new UntypedFormControl(this.data.employeeId),
      values: new UntypedFormControl(this.data.values, [
        Validators.required,
        Validators.maxLength(400),
      ]),
      hobbies: new UntypedFormControl(this.data.hobbies, [
        Validators.required,
        Validators.maxLength(400),
      ]),
    });

    this.valuesAndHobbiesForm.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(values => {
        this.dataValuesAndHobbies = values;
      });

    this.ableToEdit = !this.accessService.checkPermissions(
      roles.ACCOUNTANT_DEPARTMENT
    );
  }

  switchEdit() {
    this.isEditable = !this.isEditable;
  }

  saveData() {
    if (this.valuesAndHobbiesForm.invalid) {
      this.validateAllFormFields(this.valuesAndHobbiesForm);
      return;
    }
    this.dialogRef.close(this.dataValuesAndHobbies);
  }

  cancelSave() {
    this.dialogRef.close();
  }
}
